import clsx from 'clsx';

import { TOOLBAR_ACTIONS } from './constants';
import { ToolbarButton } from './toolbar-button';
import style from './toolbar.module.scss';

type Props = {
  className?: string;
};

export const Toolbar = ({ className }: Props) => (
  <div className={clsx(style.Toolbar, className)}>
    {TOOLBAR_ACTIONS.map(({ kind, icon, label, action }) => (
      <ToolbarButton
        key={kind}
        kind={kind}
        icon={icon}
        label={label}
        action={action}
      />
    ))}
  </div>
);
